module.exports = __webpack_public_path__ + "img/person.d73b6579.svg";